import React from 'react';
import classnames from 'classnames';
import styles from '../Dashboards.module.css';
import Selectro from 'components/common/Selectro';
import terminology from 'javascripts/terminology';

const ReleaseSelectro = ({ select, release }) => {
  const increaseZIndex = response => {
    const selectroModal = document.getElementById('selectro-modal');
    if (selectroModal) selectroModal.style.zIndex = '99999';
    return response;
  };

  return (
    <div className={classnames(styles.PanelConfigurationLayout, 'mt-3')}>
      <div className={styles.PanelConfigurationSectionSubtitle}>
        {`${terminology('Release')}`}
      </div>
      <Selectro
        nil='None'
        placeholder={`${terminology('Release')} name`}
        selectedElements={
          release ? [[release.get('name'), release.get('id')]] : []
        }
        fetchUrl='/api/v1/releases/picker'
        select={select}
        multiple={false}
        headersClickable={false}
        nocache
        fetchTransformCallback={([response]) => increaseZIndex(response)}
        classes={styles.PanelConfigurationSelectro}
        modalClassName='PanelConfigurationSidebar'
      />
    </div>
  );
};

export default ReleaseSelectro;
